<template>
    <div class="employer-content">
  
      <div class="content-card">
  
        <!-- Decorative glow -->
        <div class="card-glow card-glow-blue"></div>
        <div class="card-glow card-glow-purple"></div>
  
  
        <!-- =====================================================
             HEADER
        ====================================================== -->
  
        <div class="card-header">
  
          <div class="header-left">
  
            <div class="content-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M7 8.5H17"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
  
                <path
                  d="M7 12H14"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
  
                <path
                  d="M7 15.5H12"
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
  
                <path
                  d="M5.5 3.5H18.5C19.6046 3.5 20.5 4.39543 20.5 5.5V18.5C20.5 19.6046 19.6046 20.5 18.5 20.5H5.5C4.39543 20.5 3.5 19.6046 3.5 18.5V5.5C3.5 4.39543 4.39543 3.5 5.5 3.5Z"
                  stroke="currentColor"
                  stroke-width="1.7"
                />
              </svg>
            </div>
  
  
            <div class="header-copy">
  
              <div class="eyebrow">
                Для работодателей
              </div>
  
              <h2 class="card-title">
                Публикуйте контент от имени компании
              </h2>
  
            </div>
  
          </div>
  
  
          <div
            class="status-badge"
            :class="{ active: enabled }"
          >
            <span class="status-dot"></span>
  
            {{ enabled ? "Включено" : "Выключено" }}
          </div>
  
        </div>
  
  
        <!-- =====================================================
             DESCRIPTION
        ====================================================== -->
  
        <div class="content-copy">
  
          <h3>
            Хотите размещать контент?
          </h3>
  
          <p>
            Включите режим размещения контента, чтобы публиковать
            вакансии и ивенты от имени компаний, с которыми вы
            работаете.
          </p>
  
        </div>
  
  
        <!-- =====================================================
             FEATURES
        ====================================================== -->
  
        <div class="features">
  
          <div class="feature">
  
            <div class="feature-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M8 7V5.5C8 4.67 8.67 4 9.5 4H14.5C15.33 4 16 4.67 16 5.5V7"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
  
                <rect
                  x="4"
                  y="7"
                  width="16"
                  height="12"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
  
                <path
                  d="M4 11H20"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
              </svg>
            </div>
  
            <div>
              <div class="feature-title">
                Вакансии
              </div>
  
              <div class="feature-description">
                Создавайте и публикуйте вакансии
              </div>
            </div>
  
          </div>
  
  
          <div class="feature">
  
            <div class="feature-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  x="4"
                  y="5.5"
                  width="16"
                  height="14"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
  
                <path
                  d="M8 3.5V7"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
  
                <path
                  d="M16 3.5V7"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
  
                <path
                  d="M4 9.5H20"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
              </svg>
            </div>
  
            <div>
              <div class="feature-title">
                Ивенты
              </div>
  
              <div class="feature-description">
                Анонсируйте события вашей компании
              </div>
            </div>
  
          </div>
  
  
          <div class="feature">
  
            <div class="feature-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="9"
                  cy="9"
                  r="3"
                  stroke="currentColor"
                  stroke-width="1.6"
                />
  
                <path
                  d="M4.5 19C4.5 15.9 6.5 14 9 14C11.5 14 13.5 15.9 13.5 19"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
  
                <path
                  d="M16 8H20"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
  
                <path
                  d="M18 6V10"
                  stroke="currentColor"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </svg>
            </div>
  
            <div>
              <div class="feature-title">
                Отклики
              </div>
  
              <div class="feature-description">
                Работайте с кандидатами в одном месте
              </div>
            </div>
  
          </div>
  
        </div>
  
  
        <!-- =====================================================
             DIVIDER
        ====================================================== -->
  
        <div class="divider"></div>
  
  
        <!-- =====================================================
             SWITCH
        ====================================================== -->
  
        <div class="toggle-row">
  
          <div class="toggle-copy">
  
            <div class="toggle-title">
              Размещать контент
            </div>
  
            <div class="toggle-description">
              Вы сможете публиковать контент как представитель компании
            </div>
  
          </div>
  
  
          <button
            type="button"
            class="ios-switch"
            :class="{ active: enabled }"
            :aria-pressed="enabled"
            @click="toggle"
          >
            <span class="switch-knob"></span>
          </button>
  
        </div>
  
      </div>
  
    </div>
  </template>
  
  
  <script setup>
  
  import {
    computed
  } from "vue";
  
  
  const props = defineProps({
  
    modelValue: {
      type: Boolean,
      default: false
    }
  
  });
  
  
  const emit = defineEmits([
    "update:modelValue",
    "change"
  ]);
  
  
  const enabled = computed(() =>
    props.modelValue
  );
  
  
  const toggle = () => {
  
    const nextValue =
      !props.modelValue;
  
  
    emit(
      "update:modelValue",
      nextValue
    );
  
  
    emit(
      "change",
      nextValue
    );
  
  };
  
  </script>
  
  
  <style scoped>
  
  /* ============================================================
     ROOT
  ============================================================ */
  
  .employer-content {
    width: 100%;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  }
  
  
  /* ============================================================
     CARD
  ============================================================ */
  
  .content-card {
    position: relative;
  
    width: 100%;
  
    box-sizing: border-box;
  
    overflow: hidden;
  
    padding: 30px;
  
    background:
      linear-gradient(
        145deg,
        rgba(255, 255, 255, 0.98),
        rgba(248, 250, 253, 0.98)
      );
  
    border:
      1px solid
      rgba(20, 35, 60, 0.09);
  
    border-radius: 26px;
  
    box-shadow:
      0 18px 50px
      rgba(
        15,
        23,
        42,
        0.07
      );
  }
  
  
  /* ============================================================
     DECORATIVE GLOW
  ============================================================ */
  
  .card-glow {
    position: absolute;
  
    width: 220px;
    height: 220px;
  
    pointer-events: none;
  
    border-radius: 50%;
  
    filter: blur(65px);
  
    opacity: 0.13;
  }
  
  
  .card-glow-blue {
    top: -110px;
    right: -70px;
  
    background: #2887f7;
  }
  
  
  .card-glow-purple {
    bottom: -150px;
    left: -100px;
  
    background: #7c5ce7;
  }
  
  
  /* ============================================================
     HEADER
  ============================================================ */
  
  .card-header {
    position: relative;
  
    z-index: 2;
  
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  
    gap: 20px;
  }
  
  
  .header-left {
    display: flex;
    align-items: center;
  
    gap: 15px;
  
    min-width: 0;
  }
  
  
  .content-icon {
    width: 48px;
    height: 48px;
  
    flex:
      0
      0
      48px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    color: #357ce7;
  
    background:
      linear-gradient(
        145deg,
        rgba(40, 135, 247, 0.12),
        rgba(124, 92, 231, 0.09)
      );
  
    border:
      1px solid
      rgba(40, 120, 230, 0.13);
  
    border-radius: 15px;
  }
  
  
  .content-icon svg {
    width: 23px;
    height: 23px;
  }
  
  
  .header-copy {
    min-width: 0;
  }
  
  
  .eyebrow {
    margin-bottom: 5px;
  
    color: #8b919a;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size: 9px;
  
    letter-spacing: 0.08em;
  
    text-transform: uppercase;
  }
  
  
  .card-title {
    margin: 0;
  
    color: #242931;
  
    font-family:
      "Eastman-Bold",
      sans-serif;
  
    font-size: 17px;
  
    line-height: 1.3;
  
    letter-spacing: -0.25px;
  }
  
  
  /* ============================================================
     STATUS
  ============================================================ */
  
  .status-badge {
    display: inline-flex;
    align-items: center;
  
    gap: 6px;
  
    min-height: 27px;
  
    padding:
      0
      10px;
  
    flex-shrink: 0;
  
    color: #858a92;
  
    background:
      rgba(
        35,
        45,
        60,
        0.045
      );
  
    border:
      1px solid
      rgba(
        30,
        40,
        55,
        0.07
      );
  
    border-radius: 999px;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size: 9px;
  
    transition:
      color 0.25s ease,
      background 0.25s ease,
      border-color 0.25s ease;
  }
  
  
  .status-dot {
    width: 5px;
    height: 5px;
  
    background: #a6abb2;
  
    border-radius: 50%;
  }
  
  
  .status-badge.active {
    color: #258454;
  
    background:
      rgba(
        50,
        177,
        110,
        0.08
      );
  
    border-color:
      rgba(
        50,
        177,
        110,
        0.13
      );
  }
  
  
  .status-badge.active
  .status-dot {
    background: #39b974;
  }
  
  
  /* ============================================================
     COPY
  ============================================================ */
  
  .content-copy {
    position: relative;
  
    z-index: 2;
  
    max-width: 600px;
  
    margin-top: 30px;
  }
  
  
  .content-copy h3 {
    margin:
      0
      0
      8px;
  
    color: #30353d;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size: 14px;
  
    font-weight: 500;
  }
  
  
  .content-copy p {
    margin: 0;
  
    color: #747b85;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size: 12px;
  
    line-height: 1.55;
  }
  
  
  /* ============================================================
     FEATURES
  ============================================================ */
  
  .features {
    position: relative;
  
    z-index: 2;
  
    display: grid;
  
    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );
  
    gap: 10px;
  
    margin-top: 23px;
  }
  
  
  .feature {
    min-width: 0;
  
    display: flex;
    align-items: center;
  
    gap: 10px;
  
    padding:
      13px
      12px;
  
    background:
      rgba(
        255,
        255,
        255,
        0.65
      );
  
    border:
      1px solid
      rgba(
        30,
        45,
        65,
        0.07
      );
  
    border-radius: 14px;
  }
  
  
  .feature-icon {
    width: 33px;
    height: 33px;
  
    flex:
      0
      0
      33px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    color: #4e79d7;
  
    background:
      rgba(
        48,
        112,
        224,
        0.07
      );
  
    border-radius: 10px;
  }
  
  
  .feature-icon svg {
    width: 17px;
    height: 17px;
  }
  
  
  .feature-title {
    color: #373c44;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size: 10px;
  }
  
  
  .feature-description {
    margin-top: 3px;
  
    color: #91969e;
  
    font-size: 8px;
  
    line-height: 1.35;
  }
  
  
  /* ============================================================
     DIVIDER
  ============================================================ */
  
  .divider {
    position: relative;
  
    z-index: 2;
  
    height: 1px;
  
    margin:
      26px
      0
      21px;
  
    background:
      rgba(
        25,
        40,
        60,
        0.075
      );
  }
  
  
  /* ============================================================
     TOGGLE ROW
  ============================================================ */
  
  .toggle-row {
    position: relative;
  
    z-index: 2;
  
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    gap: 30px;
  }
  
  
  .toggle-copy {
    min-width: 0;
  }
  
  
  .toggle-title {
    color: #343941;
  
    font-family:
      "Eastman-Medium",
      sans-serif;
  
    font-size: 12px;
  }
  
  
  .toggle-description {
    margin-top: 4px;
  
    color: #959aa2;
  
    font-size: 9px;
  
    line-height: 1.4;
  }
  
  
  /* ============================================================
     IOS SWITCH
  ============================================================ */
  
  .ios-switch {
    position: relative;
  
    width: 51px;
    height: 31px;
  
    flex:
      0
      0
      51px;
  
    padding: 0;
  
    overflow: hidden;
  
    appearance: none;
    -webkit-appearance: none;
  
    background: #d8dbe0;
  
    border: none;
    border-radius: 999px;
  
    outline: none;
  
    cursor: pointer;
  
    box-shadow:
      inset
      0
      0
      0
      1px
      rgba(
        0,
        0,
        0,
        0.025
      );
  
    transition:
      background-color
      0.25s ease,
      box-shadow
      0.25s ease;
  }
  
  
  .switch-knob {
    position: absolute;
  
    top: 3px;
    left: 3px;
  
    width: 25px;
    height: 25px;
  
    background: #ffffff;
  
    border-radius: 50%;
  
    box-shadow:
      0 2px 7px
      rgba(
        0,
        0,
        0,
        0.22
      );
  
    transition:
      transform
      0.28s
      cubic-bezier(
        0.22,
        1,
        0.36,
        1
      );
  }
  
  
  .ios-switch.active {
    background: #34c759;
  
    box-shadow:
      0
      5px
      14px
      rgba(
        52,
        199,
        89,
        0.22
      );
  }
  
  
  .ios-switch.active
  .switch-knob {
    transform:
      translateX(20px);
  }
  
  
  /* ============================================================
     DARK
  ============================================================ */
  
  html[data-theme="dark"]
  .content-card {
    background:
      linear-gradient(
        145deg,
        #22242a,
        #1c1e23
      );
  
    border-color:
      rgba(
        255,
        255,
        255,
        0.075
      );
  
    box-shadow:
      0
      20px
      55px
      rgba(
        0,
        0,
        0,
        0.28
      );
  }
  
  
  html[data-theme="dark"]
  .card-title {
    color: #f3f4f6;
  }
  
  
  html[data-theme="dark"]
  .eyebrow {
    color: #818690;
  }
  
  
  html[data-theme="dark"]
  .content-copy h3 {
    color: #e6e8eb;
  }
  
  
  html[data-theme="dark"]
  .content-copy p {
    color: #9da2ab;
  }
  
  
  html[data-theme="dark"]
  .feature {
    background:
      rgba(
        255,
        255,
        255,
        0.035
      );
  
    border-color:
      rgba(
        255,
        255,
        255,
        0.065
      );
  }
  
  
  html[data-theme="dark"]
  .feature-title {
    color: #dcdee2;
  }
  
  
  html[data-theme="dark"]
  .feature-description {
    color: #858a93;
  }
  
  
  html[data-theme="dark"]
  .divider {
    background:
      rgba(
        255,
        255,
        255,
        0.07
      );
  }
  
  
  html[data-theme="dark"]
  .toggle-title {
    color: #e5e7ea;
  }
  
  
  html[data-theme="dark"]
  .toggle-description {
    color: #858a94;
  }
  
  
  html[data-theme="dark"]
  .ios-switch {
    background: #4b4e55;
  }
  
  
  /* ============================================================
     MOBILE
  ============================================================ */
  
  @media (max-width: 700px) {
  
    .content-card {
      padding: 20px;
  
      border-radius: 20px;
    }
  
  
    .card-header {
      flex-direction: column;
  
      gap: 14px;
    }
  
  
    .content-copy {
      margin-top: 24px;
    }
  
  
    .features {
      grid-template-columns: 1fr;
    }
  
  
    .feature {
      padding: 12px;
    }
  
  
    .toggle-row {
      gap: 18px;
    }
  
  
    .toggle-description {
      max-width: 210px;
    }
  
  }
  
  </style>